
const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';

const STANDARD_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:m:ss';

const DISPLAYED_DATE_FORMAT = 'DD/MM/YYYY';

const DISPLAYED_DATE_HM_FORMAT = 'DD/MM/YYYY HH:mm';

const DISPLAYED_DATE_HMS_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export {
    STANDARD_DATE_FORMAT,
    STANDARD_DATE_TIME_FORMAT,
    DISPLAYED_DATE_FORMAT,
    DISPLAYED_DATE_HM_FORMAT,
    DISPLAYED_DATE_HMS_FORMAT,
}
